{
    "v": "4.8.0",
    "meta": {
        "g": "LottieFiles AE 1.0.0",
        "a": "",
        "k": "24",
        "d": "",
        "tc": ""
    },
    "fr": 25,
    "ip": 0,
    "op": 37,
    "w": 500,
    "h": 500,
    "nm": "33 Question",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 26, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Bubble",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.338], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 2,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.176], "y": [1] },
                            "o": { "x": [0.775], "y": [0] },
                            "t": 7,
                            "s": [9]
                        },
                        {
                            "i": { "x": [0.405], "y": [1] },
                            "o": { "x": [0.658], "y": [0] },
                            "t": 10,
                            "s": [-11]
                        },
                        {
                            "i": { "x": [0.261], "y": [1] },
                            "o": { "x": [0.14], "y": [0] },
                            "t": 15,
                            "s": [4]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 19,
                            "s": [-1.043]
                        },
                        { "t": 26, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [-140, 194.621, 0], "ix": 2 },
                "a": { "a": 0, "k": [-190, 144.621, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [-6.021, 28.547],
                                        [0, 0],
                                        [0, 29.379],
                                        [-95.456, 0],
                                        [0, -96.164],
                                        [95.456, 0],
                                        [27.782, 19.197],
                                        [0, 0],
                                        [21.588, 0],
                                        [12.908, 14.843]
                                    ],
                                    "o": [
                                        [26.02, -11.294],
                                        [0, 0],
                                        [-12.754, -24.277],
                                        [0, -96.164],
                                        [95.456, 0],
                                        [0, 96.164],
                                        [-36.234, 0],
                                        [0, 0],
                                        [-12.918, 15.409],
                                        [-21.127, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-188.648, 144.668],
                                        [-137.034, 81.327],
                                        [-137.051, 81.336],
                                        [-157.028, 0],
                                        [15.811, -174.121],
                                        [188.65, 0],
                                        [15.811, 174.121],
                                        [-81.835, 143.691],
                                        [-81.835, 143.69],
                                        [-135.661, 168.885],
                                        [-188.65, 144.67]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3, "x": "" },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 26.94,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Question 1",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 22,
                            "s": [0]
                        },
                        { "t": 30, "s": [180] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [13.868, 75.787, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 5.643],
                                        [0, -5.643]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": ""
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 26.94,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Question 2",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 5,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 11,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 15,
                            "s": [-10]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 19,
                            "s": [4]
                        },
                        { "t": 22, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 5,
                            "s": [15.811, 18.232, 0],
                            "to": [0, 5.833, 0],
                            "ti": [0, 2.167, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 11,
                            "s": [15.811, 53.232, 0],
                            "to": [0, -2.167, 0],
                            "ti": [0, 4.333, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 15,
                            "s": [15.811, 5.232, 0],
                            "to": [0, -4.333, 0],
                            "ti": [0, -2.167, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 19,
                            "s": [15.811, 27.232, 0],
                            "to": [0, 2.167, 0],
                            "ti": [0, 1.5, 0]
                        },
                        { "t": 22, "s": [15.811, 18.232, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [0, 49.448, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [-15.586, -0.559],
                                        [-0.751, -19.777],
                                        [17.761, -3.698],
                                        [0, -4.603],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [6.409, -12.986],
                                        [19.778, 0.709],
                                        [0.722, 19.019],
                                        [-4.507, 0.938],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-36.141, -28.189],
                                        [-0.555, -49.423],
                                        [36.112, -12.835],
                                        [5.848, 25.947],
                                        [-1.957, 35.346],
                                        [-1.957, 49.448]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": ""
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 26.94,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
